/**Dependencies */
import React, { useEffect, useState } from "react";

// Styles
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import { booking, getInfoReserva } from "../services/Booking";
import { Loader } from "../components/Loader";
import { ReservaConfirmada } from "../components/ReservaConfirmada";
import { ErrorReserva } from "../components/ErrorReserva";
import {
  getEmailConfirmReserva,
  getEmailErrorReserva,
  getEmailPagoExitoso,
} from "../services/emailService";

export const ConfirmReserva = () => {
  const [dataCart] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva"))
  );
  const [dataCartPP] = useState(
    JSON.parse(sessionStorage.getItem("datosReservaPP"))
  );
  // eslint-disable-next-line no-unused-vars
  const [reservaSession, setReservaSession] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva")) || null
  );
  const [reserva, setReserva] = useState({});
  const [reservaInfo, setReservaInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [total, setTotal] = useState();
  let cart;
  const location = useLocation();
  const navigate = useNavigate();
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const queryParams = parseQueryParams(location.search);

  useEffect(() => {
    // if (reservaSession !== null) {
    //   sessionStorage.clear();
    //   navigate("/");
    // } else {
    if (dataCart === null || reservaSession === undefined) {
      navigate("/");
    } else {
      bookingReserva();
    }
    // }
  }, []);
  if (dataCartPP) {
    cart = {
      productoPropio: dataCartPP,
    };
  } else if (
    dataCart?.hospedaje?.length > 0 &&
    dataCart?.actividades?.length > 0 &&
    dataCart?.traslados?.length > 0
  ) {
    cart = {
      hotel: dataCart?.hospedaje,
      experiencia: dataCart?.actividades,
      traslado: dataCart?.traslados,
    };
  } else if (
    dataCart?.hospedaje?.length > 0 &&
    dataCart?.actividades?.length === 0 &&
    dataCart?.traslados?.length === 0
  ) {
    cart = {
      hotel: dataCart?.hospedaje,
    };
  } else if (
    dataCart?.hospedaje?.length === 0 &&
    dataCart?.actividades?.length > 0 &&
    dataCart?.traslados?.length === 0
  ) {
    cart = {
      experiencia: dataCart?.actividades,
    };
  } else if (
    dataCart?.hospedaje?.length === 0 &&
    dataCart?.actividades?.length === 0 &&
    dataCart?.traslados?.length > 0
  ) {
    cart = {
      traslado: dataCart?.traslados,
    };
  } else if (
    dataCart?.hospedaje?.length > 0 &&
    dataCart?.actividades?.length > 0 &&
    dataCart?.traslados?.length === 0
  ) {
    cart = {
      hotel: dataCart?.hospedaje,
      experiencia: dataCart?.actividades,
    };
  } else if (
    dataCart?.hospedaje?.length > 0 &&
    dataCart?.actividades?.length === 0 &&
    dataCart?.traslados?.length > 0
  ) {
    cart = {
      hotel: dataCart?.hospedaje,
      traslado: dataCart?.traslados,
    };
  } else if (
    dataCart?.hospedaje?.length === 0 &&
    dataCart?.actividades?.length > 0 &&
    dataCart?.traslados?.length > 0
  ) {
    cart = {
      experiencia: dataCart?.actividades,
      traslado: dataCart?.traslados,
    };
  }
  const bookingReserva = async () => {
    let req;
    if (
      dataCart?.idPasarela === "CONEKTA" ||
      dataCartPP?.idPasarela === "CONEKTA"
    ) {
      req = {
        idPasarela: dataCart?.idPasarela || dataCartPP?.idPasarela,
        idTransaccion: queryParams?.order_id,
        codigoPais:
          dataCart?.hospedaje[0]?.codigoPais ||
          dataCart?.actividades[0]?.codigo_pais ||
          dataCart?.traslados[0]?.codigo_pais ||
          "",
        carrito: cart,
      };
    } else if (
      dataCart?.idPasarela === "OPENPAY" ||
      dataCartPP?.idPasarela === "OPENPAY"
    ) {
      req = {
        idPasarela: dataCart?.idPasarela || dataCartPP?.idPasarela,
        idTransaccion: queryParams?.id,
        codigoPais:
          dataCart?.hospedaje[0]?.codigoPais ||
          dataCart?.actividades[0]?.codigo_pais ||
          dataCart?.traslados[0]?.codigo_pais ||
          "",
        carrito: cart,
      };
    } else if (
      dataCart?.idPasarela === "STRIPE" ||
      dataCartPP?.idPasarela === "STRIPE"
    ) {
      req = {
        idPasarela: dataCart?.idPasarela || dataCartPP?.idPasarela,
        idTransaccion: queryParams?.id,
        codigoPais:
          dataCart?.hospedaje[0]?.codigoPais ||
          dataCart?.actividades[0]?.codigo_pais ||
          dataCart?.traslados[0]?.codigo_pais ||
          "",
        carrito: cart,
      };
    }
    try {
      const response = await booking(req);

      infoReserva(response.idReserva);
      setReserva(response);
      const reservaSessions = sessionStorage.setItem(
        "reservaSession",
        JSON.stringify(response)
      );
      setReservaSession(reservaSessions);
      sendMails(response);

      const redirectTimer = setTimeout(() => {
        sessionStorage.removeItem("reservaSession");
        sessionStorage.removeItem("datosReserva");
        sessionStorage.removeItem("datosURL");
        window.location.href = "/"; // Redirección absoluta
      }, 60000); // 40 segundos

      // 4. Guardar el timer ID para limpieza si el componente se desmonta
      sessionStorage.setItem("redirectTimer", redirectTimer.toString());

      // 5. Manejar evento de beforeunload (recarga de página)
      window.addEventListener("beforeunload", handlePageReload);

      // 6. Manejar navegación hacia atrás
      window.addEventListener("popstate", handleBackNavigation);
    } catch (error) {
      setLoading(false);
      throw new Error("error connection", error);
    }
  };

  const sendMails = async (res) => {
    if (res.error == true) {
      const dataErrorEmail = {
        destinatario: res.emailTitular,
        destinatarioCC: "",
        asunto: "Reservacion Marzah Travel",
        mensaje: "Error en la reserva",
        infoError: res,
      };
      const errorMail = await ErrorEmail(dataErrorEmail);
      return errorMail;
    } else {
      const dataEmailConfirm = {
        asunto: "Reservacion Marzah Travel",
        destinatario: res.emailTitular,
        destinatarioCC: "",
        mensaje: "Reservacion confirmada",
        rateComments: rateComments,
        responseReserva: res,
        ...(dataCart?.actividades?.length > 0 && {
          observacionesExperiencias: [
            dataCart?.actividades?.[0]?.observaciones,
          ],
        }),
        ...(dataCart?.traslados?.length > 0 && {
          comentariosTraslados: [
            dataCart?.traslados?.[0]?.observacionesTraslados,
            dataCart?.traslados?.[1]
              ? dataCart?.traslados?.[1]?.observacionesTraslados
              : "",
          ],
        }),
      };

      const dataEmailPagoExitoso = {
        destinatario: res.emailTitular,
        destinatarioCC: "",
        asunto: "Pago Exitoso Marzah Travel",
        mensaje: "Pago exitoso",
        idReserva: res.idReserva,
      };
      const confirmMail = await sendEmailConfirm(dataEmailConfirm);
      const pagoExitosoMail = await pagoExitosoEmail(dataEmailPagoExitoso);
      return { confirmMail, pagoExitosoMail };
    }
  };
  const infoReserva = async (idReserva) => {
    try {
      const response = await getInfoReserva({ idReserva: idReserva });
      setReservaInfo(response);
      setLoading(false);
    } catch (error) {
      throw new Error("error connection", error);
    }
  };
  useEffect(() => {
    const totalReserva = async () => {
      const total = await reserva?.totalPago;
      let impuesto = total * 0.16;
      let subtotal = total - impuesto;
      setTotal({ subtotal, impuesto, total });
    };
    totalReserva();
  }, [reservaInfo]);

  const ErrorEmail = async (dataError) => {
    try {
      const response = await getEmailErrorReserva(dataError);
      return response;
    } catch (error) {
      throw new Error("error", error);
    }
  };

  const sendEmailConfirm = async (dataConfirm) => {
    try {
      const response = await getEmailConfirmReserva(dataConfirm);
      return response;
    } catch (error) {
      throw new Error("error", error);
    }
  };

  const pagoExitosoEmail = async (dataPagoSuccess) => {
    try {
      const response = await getEmailPagoExitoso(dataPagoSuccess);
      return response;
    } catch (error) {
      throw new Error("error", error);
    }
  };

  const rateComments = dataCart?.hospedaje?.map((hotel) => {
    return hotel?.rateComments;
  });

  const handlePageReload = (e) => {
    // Limpiar sessionStorage
    sessionStorage.removeItem("reservaSession");
    sessionStorage.removeItem("datosReserva");
    sessionStorage.removeItem("datosURL");

    // Cancelar el timer si existe
    const timerId = sessionStorage.getItem("redirectTimer");
    if (timerId) {
      clearTimeout(parseInt(timerId));
      sessionStorage.removeItem("redirectTimer");
    }

    // Redirigir al home
    navigate("/");

    // Algunos navegadores requieren esto para mostrar el mensaje de confirmación
    e.preventDefault();
    e.returnValue = "";
  };

  // Función para manejar navegación hacia atrás
  const handleBackNavigation = () => {
    // Limpiar sessionStorage
    sessionStorage.removeItem("reservaSession");
    sessionStorage.removeItem("datosReserva");
    sessionStorage.removeItem("datosURL");

    // Cancelar el timer si existe
    const timerId = sessionStorage.getItem("redirectTimer");
    if (timerId) {
      clearTimeout(parseInt(timerId));
      sessionStorage.removeItem("redirectTimer");
    }

    // Redirigir al home
    navigate("/");
  };

  // Limpieza de efectos al desmontar el componente
  useEffect(() => {
    return () => {
      window.removeEventListener("beforeunload", handlePageReload);
      window.removeEventListener("popstate", handleBackNavigation);

      // Limpiar timer si el componente se desmonta
      const timerId = sessionStorage.getItem("redirectTimer");
      if (timerId) {
        clearTimeout(parseInt(timerId));
        sessionStorage.removeItem("redirectTimer");
      }
    };
  }, []);

  return (
    <div
      style={
        Object.keys(reserva).length > 0
          ? {
              //backgroundImage: `url(https://panel.marzahtravel.com/assets/img/fondoCorreo.png)`,
              //backgroundRepeat: "repeat",
              //backgroundSize: "contain",
              width: "100%",
            }
          : {
              //backgroundImage: `url(https://panel.marzahtravel.com/assets/img/fondoCorreo.png)`,
              //backgroundRepeat: "repeat",
              //backgroundSize: "contain",
              width: "100%",
              height: "100vh",
            }
      }
    >
      {loading && <Loader />}
      <Button
        className="w-auto m-3"
        style={{ border: "0", backgroundColor: "#1763af" }}
        onClick={() => [navigate("/"), sessionStorage.clear()]}
      >
        Regresar al Home
      </Button>
      {Object.keys(reserva)?.length > 0 && (
        <>
          {reserva?.error === false || (reserva?.error === 0 && reservaInfo) ? (
            <div className="container d-flex justify-content-center position-relative">
              <div
                className="bg-white p-5 pb-2 mx-5 mb-5 shadow rounded"
                style={{ marginTop: "10rem" }}
              >
                <ReservaConfirmada
                  arrReserva={dataCart ? dataCart : dataCartPP}
                  arrReservaInfo={reservaInfo}
                  reserva={reserva}
                  showLoader={loading}
                />
              </div>
            </div>
          ) : (
            <div className="container d-flex justify-content-center position-relative">
              <div className="bg-white p-5 pb-2 m-5 shadow rounded">
                <ErrorReserva
                  // reserva={reserva}
                  // idTransaccion={queryParams.id}
                  showLoader={loading}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
